import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const MAX_CONTAINER_WIDTH = 755;

export const SMALL_COLUMN_MIN_WIDTH = 100;

export const LARGE_COLUMN_MIN_WIDTH = 200;

export const ICON_COLUMN_MIN_WIDTH = 60;

export const WAREHOUSE_COLUMN_WIDTH = 105;

export const InitialLineDetails = {
  FromWarehouse: '',
  LineNumber: [],
  ProductId: 0
};

export const getColumns = (
  headerFiltersDataSource,
  warehouseColumns,
  selectedWarehouse,
  classes,
  warehouseCellRenderer,
  getHeaderCellRender
) => {
  const baseColumns = [
    {
      dataField: 'ProductIdDisplay',
      caption: 'Product',
      width: COLUMN_SIZE.lg0,
    },
    {
      dataField: 'OnOrderDisplay',
      caption: 'On Order',
      width: COLUMN_SIZE.md0,
      alignment: 'right',
      allowFiltering: false
    },
    {
      dataField: 'RemainingDisplay',
      caption: 'Remaining',
      width: COLUMN_SIZE.md0,
      alignment: 'right',
      headerFiltersDataSource: headerFiltersDataSource?.Backorder || []
    },
    {
      dataField: 'WarehouseLabel',
      caption: 'Warehouse',
      width: WAREHOUSE_COLUMN_WIDTH,
      headerFiltersDataSource: headerFiltersDataSource?.Warehouse || []
    },
    {
      dataField: 'Status',
      caption: 'Status',
      width: COLUMN_SIZE.lg1,
      headerFiltersDataSource: headerFiltersDataSource?.Status || []
    }
  ];

  const dynamicWarehouseColumns = warehouseColumns.map((col) => ({
    key: col.DataField,
    cssClass: col.Warehouse === selectedWarehouse ? classes.highlight : undefined,
    dataField: col.DataField,
    allowFiltering: false,
    width: SMALL_COLUMN_MIN_WIDTH,
    cellRender: warehouseCellRenderer,
    headerCellRender: () => getHeaderCellRender(col),
    visible: !col.Hidden
  }));

  const descriptionColumn = {
    dataField: 'Description',
    caption: 'Description',
    width: COLUMN_SIZE.xl0,
    allowFiltering: false
  };

  return [
    ...baseColumns,
    ...dynamicWarehouseColumns,
    descriptionColumn
  ];
};
